<template>
  <a :class="[likeLoading ? 'is-flashing' : '', 'cm-button', 'is-inverted']" @click.prevent="toggleLike">
    <template v-if="liked">
      Unlike
    </template>
    <template v-else>
      Like
    </template>
  </a>
</template>

<script>
  export default {
    props: ['company'],

    data () {
      return {
        liked: this.company.liked,
        likeLoading: false
      }
    },

    methods: {
      toggleLike () {
        this.likeLoading = true

        if (!this.liked) {
          window.makeItRainHearts()
        }

        this.$http.put(`/companies/${this.company.slug}/like.json`).then(response => {
          this.liked = !this.liked

          this.likeLoading = false
        }, response => {
          // TODO Display error messages
        });
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// app/javascript/company/like.vue?6f7f7868